import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "order-card-item-details" }
const _hoisted_2 = { class: "d-flex justify-space-between" }
const _hoisted_3 = { class: "font-size-12-600 title-text" }
const _hoisted_4 = { class: "text-right font-size-16-600" }
const _hoisted_5 = {
  key: 0,
  class: "font-size-12-600"
}
const _hoisted_6 = { class: "font-size-12-400 font-grey-dark" }
const _hoisted_7 = { class: "mb-3 mt-1" }
const _hoisted_8 = { class: "font-size-12-400" }
const _hoisted_9 = { class: "font-size-12-600" }
const _hoisted_10 = {
  key: 1,
  class: "d-flex align-center ga-1"
}
const _hoisted_11 = { class: "font-size-12-600" }
const _hoisted_12 = { class: "d-flex align-center ga-1 mt-1" }
const _hoisted_13 = { class: "font-size-12-600" }
const _hoisted_14 = {
  key: 3,
  class: "mt-4 d-flex align-center ga-1"
}
const _hoisted_15 = {
  key: 1,
  class: "avatar-container__initials primary-background-button-color"
}
const _hoisted_16 = { class: "font-size-12-600" }
const _hoisted_17 = {
  key: 4,
  class: "text-right mt-3"
}
const _hoisted_18 = {
  key: 5,
  class: "border-bottom mt-5"
}
const _hoisted_19 = {
  key: 0,
  class: "consultation-comments mt-4"
}
const _hoisted_20 = { class: "d-flex ga-2" }
const _hoisted_21 = { class: "comment-icon" }
const _hoisted_22 = { class: "comment-container font font-grey-dark" }
const _hoisted_23 = {
  key: 0,
  class: "border-bottom mt-4"
}
const _hoisted_24 = {
  key: 1,
  class: "text-right"
}

import {ref, computed} from 'vue';
import Icon from "@/components/Icons/Icon.vue";
import moment from "moment/moment";
import InstalmentsDetails from "@/views/OrdersComponents/OrderDetails/ServicePackageDetails/InstalmentsDetails.vue";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'ServicePackageDetails',
  props: {
  item: {
    type: Object,
    required: true
  },
  paymentStatus: {
    type: Object,
    default: () => ({color: '', status: ''})
  },
  isClinicServiceOrPackage: {
    type: Boolean,
    default: false
  },
  supplierOrder: {
    type: Object,
    default: () => ({})
  },
  order: {
    type: Object,
    default: () => ({})
  },
  supplierId: {
    type: String,
  }
},
  setup(__props) {

const router = useRouter();

const props = __props;

const showMore = ref(true);

const toggleShowMore = () => {
  showMore.value = !showMore.value;
};

const truncateText = (text: string, limit: number) => {
  if (!text) return '';
  if (text.length <= limit) return text;
  return text.slice(0, limit) + '...';
};

const getFormattedComment = (consultation) => {
  const text = getConsultationCommentOrProductDescription(consultation);
  if (showMore.value) {
    return truncateText(text, 100);
  }
  return text;
};

const getImage = computed(() => {
  // return '/img/empty-square.png';
  return null;
})

const getIcon = computed(() => {
  switch (props.item.type) {
    case 'clinic_service':
    case 'service':
      return 'service-icon';
    case 'package':
    case 'clinic_package':
      return 'package-icon';
  }
  return null;
})

const getTitle = computed(() => {
  return props.item.name ?? '';
})

const getPrice = computed(() => {
  return props.item.price_display ?? '-';
})

const isPackage = computed(() => {
  return props.item.type === 'clinic_package' || props.item.type === 'package'
})

const getConsultationCommentOrProductDescription = (consultation) => {
  return consultation.consultation?.comment ?? consultation.clinic_service?.description;
}

const getMethodIconOrLabel = (consultation) => {
  let icon;
  let label;

  switch (consultation.method) {
    case 'In Person':
    case 'in-person':
      icon = 'location-icon'
      label = 'In Person'
      break
    case 'Phone Call':
      icon = 'phone-icon'
      label = 'Phone Call'
      break
    case 'Video':
      icon = 'video-icon'
      label = 'Video'
      break
    default:
      icon = null
  }

  return {
    'icon': icon,
    'label': label
  }
}

const getConsultationDate = (consultation) => {
  if (consultation?.event !== null) {
    return moment(consultation?.event.start_date).format("HH:mm ddd, MMMM DD") ?? '';
  }

  return null;
}

const getStatus = (consultation) => {
  if (consultation?.confirmed_with_client == false) {
    return 'Unconfirmed';
  }

  return 'Confirmed';
}

const getAvatar = (consultation) => {
  if (consultation.assignee_id && consultation.assignee) {
    const firstName = consultation.assignee.first_name ?? '';
    const lastName = consultation.assignee.last_name ?? '';

    if (consultation.assignee.image) {
      return {
        image: consultation.assignee.image.file?.file_path ?? '',
        initials: null,
        name: `${firstName} ${lastName}`
      };
    }

    if (firstName || lastName) {
      return {
        image: null,
        initials: (firstName[0] + (lastName[0] || '')).toUpperCase(),
        name: `${firstName} ${lastName}`
      };
    }
  }
  return null;
};

const onJoin = (consultation) => {
  if (consultation.link) {
    window.open(consultation.link, '_blank', 'noopener,noreferrer');
  } else {
    router.push({ name: 'video-session', params: { eventId: consultation.event.id } });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      (getImage.value)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: 0,
            class: "logo-container m-0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                style: _normalizeStyle({backgroundImage: `url(${getImage.value})`}),
                class: "logo-container__image"
              }, null, 4)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_sheet, {
            key: 1,
            class: _normalizeClass([{'secondary-background-button-color': __props.supplierId === 'clinic'}, "icon-container"])
          }, {
            default: _withCtx(() => [
              _createVNode(Icon, { icon: getIcon.value }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["class"])),
      _createVNode(_component_v_card_text, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(getTitle.value), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, _toDisplayString(getPrice.value), 1),
              _createElementVNode("p", {
                class: _normalizeClass([__props.paymentStatus.color, "font-size-12-600"]),
                style: {"width":"68px"}
              }, _toDisplayString(__props.paymentStatus.status), 3)
            ])
          ]),
          (__props.supplierOrder.consultation)
            ? (_openBlock(), _createElementBlock("section", {
                key: 0,
                class: _normalizeClass({'two-line-ellipsis': showMore.value})
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.supplierOrder.consultation, (consultation, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `consultation-${index}`,
                    class: "mt-4"
                  }, [
                    (isPackage.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                          _createElementVNode("span", _hoisted_6, "(" + _toDisplayString(index + 1) + ")", 1),
                          _createTextVNode(" " + _toDisplayString(consultation.clinic_service.name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("p", _hoisted_8, [
                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-grey-dark" }, "Status: ", -1)),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(getStatus(consultation)), 1)
                      ])
                    ]),
                    (getConsultationDate(consultation))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(Icon, { icon: "calendar-icon" }),
                          _createElementVNode("p", _hoisted_11, _toDisplayString(getConsultationDate(consultation)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(Icon, {
                        icon: getMethodIconOrLabel(consultation).icon
                      }, null, 8, ["icon"]),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(getMethodIconOrLabel(consultation).label), 1)
                    ]),
                    (__props.order.instalments.length > 0 && !isPackage.value)
                      ? (_openBlock(), _createBlock(InstalmentsDetails, {
                          key: 2,
                          order: __props.order,
                          supplierOrder: __props.supplierOrder
                        }, null, 8, ["order", "supplierOrder"]))
                      : _createCommentVNode("", true),
                    (consultation?.assignee)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_v_sheet, { class: "avatar-container" }, {
                            default: _withCtx(() => [
                              (getAvatar(consultation).image)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    style: _normalizeStyle({ backgroundImage: `url(${getAvatar(consultation).image})` }),
                                    class: "avatar-container__image"
                                  }, null, 4))
                                : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(getAvatar(consultation).initials), 1)),
                              _createVNode(_component_v_overlay, {
                                activator: "parent",
                                "location-strategy": "connected",
                                "scroll-strategy": "close"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card, { class: "pa-2" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(getAvatar(consultation).name), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("p", _hoisted_16, _toDisplayString(consultation?.assignee.first_name) + " " + _toDisplayString(consultation?.assignee.last_name), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (consultation?.assignee && consultation.method === 'Video' && consultation.event)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_v_btn, {
                            class: "b-round-20 join-video-btn mb-2",
                            elevation: "0",
                            height: "32px",
                            "x-small": "",
                            onClick: ($event: any) => (onJoin(consultation))
                          }, {
                            default: _withCtx(() => [
                              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "mr-1" }, "Join", -1)),
                              _createVNode(Icon, { icon: "video-icon-lg" })
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (index !== __props.supplierOrder.consultation.length -1)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_18))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    (__props.supplierOrder.consultation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.supplierOrder.consultation, (consultation, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `consultation-comment-${index}`,
              class: "comment-section mb-4"
            }, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(Icon, { icon: "message-icon" })
                ]),
                _createElementVNode("div", _hoisted_22, _toDisplayString(getFormattedComment(consultation)), 1)
              ]),
              (index !== __props.supplierOrder.consultation.length -1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (__props.supplierOrder.consultation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(_component_v_btn, {
            ripple: false,
            class: "primary-underline-button text-capitalize font-size-12-600 pa-0",
            variant: "plain",
            onClick: toggleShowMore
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(showMore.value ? 'Show More' : 'Show Less'), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})